import { call, select } from 'redux-saga/effects'

import store from '../..'
import { setAppBeforeUnload } from '../../actions/tracking'
import { selectCampaignName, selectCampaignRetailerId } from '../../selectors/campaign'
import { prepareTrackingUrl } from './providers/streamfully'

function* initUnloadTracking() {
  const campaignName = yield select(selectCampaignName)
  const retailerId = yield select(selectCampaignRetailerId)
  const at = {
    s2s_ea: 'end',
    s2s_el: campaignName,
    s2s_ev: retailerId,
  }
  const url = yield call(prepareTrackingUrl, at)

  yield call(window.addEventListener, 'beforeunload', () => {
    navigator.sendBeacon(url)
    store.dispatch(setAppBeforeUnload())
  }, false)
}

export default initUnloadTracking
